import { render, staticRenderFns } from "./sign-tabs.vue?vue&type=template&id=cfbfc6fa"
import script from "./sign-tabs.vue?vue&type=script&lang=js"
export * from "./sign-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports